<script lang="ts" setup>
import BackgroundImage from '@/page/infrastructure/components/BackgroundImage.vue';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const { getBaseUrl } = useUrlHelper();
</script>

<template>
  <BackgroundImage img="/assets/img/coveredCalifornia/half-half-family.jpg" alt="Niña patinando" width="960" height="717" id="life-happens" reverse>
    <div class="flex flex-col space-y-6">
      <span class="text-2xl lg:text-3xl font-bold text-black">¿Qué hace California Health Exchange?</span>
      <p>
        El Mercado ayuda a los californianos a cumplir con el mandato de Obamacare. Ayuda a personas y familias a
        <a :href="getBaseUrl('/covered-california/insurance')" class="text-blue-500 hover:underline">obtener cobertura de salud</a>
        que incluya los beneficios esenciales mínimos exigidos por la ley. Ciertas aseguradoras están certificadas para
        ofrecer
        <a :href="getBaseUrl('/covered-california/plans')" class="text-blue-500 hover:underline">planes de Obama Care subsidiados y planes a precio completo</a>
        y planes dentales a través del Mercado. Estas
        <a :href="getBaseUrl('/covered-california/health-insurance-companies')" class="text-blue-500 hover:underline">aseguradoras</a>
        pueden vender seguros dentro o fuera del Mercado. Pero para los consumidores que califican, las tarifas pueden
        ser mejores si el plan médico se compra a través del mercado.
      </p>
      <p>
        Para las personas con un ingreso familiar inferior al 400% del
        <a :href="getBaseUrl('/federal-poverty-level')" class="text-blue-500 hover:underline">Nivel Federal de Pobreza</a>
        (“FPL”, por sus siglas en inglés), Covered California puede calificarlas para recibir asistencia financiera,
        también llamada
        “<a :href="getBaseUrl('/covered-california/subsidy-tax-credits')" class="text-blue-500 hover:underline">Subsidio</a>”,
        que reduce su prima. Y si el ingreso está entre el 138% y el 250% del FPL, el Mercado Estatal también puede
        calificar a las personas para descuentos adicionales que reducen su costo por servicios médicos. Estos
        descuentos adicionales se conocen como
        “<a :href="getBaseUrl('/covered-california/cost-sharing')" class="text-blue-500 hover:underline">Reducciones de Costos Compartidos</a>”.
        Para ser elegible para un subsidio y posiblemente para reducciones de costos compartidos, debes estar dentro de
        los
        <a :href="getBaseUrl('/covered-california/income-limits')" class="text-blue-500 hover:underline">límites de ingresos de Covered California</a>
        y no tener acceso a atención médica asequible y de cobertura total a través de un empleador, Medicare, etc. Las
        inscripciones deben enviarse a través del Mercado Estatal, un Agente de Seguros Certificado o un Consejero de
        Inscripción Certificado.
      </p>
    </div>
  </BackgroundImage>
</template>
